<dx-tab-panel
  width="100%"
  height="100%"
  #tabPanel
  [dataSource]="tabs"
  [(selectedIndex)]="selectedIndex"
  [loop]="false"
  [animationEnabled]="false"
  [showNavButtons]="true"
  [swipeEnabled]="false">
  <div *dxTemplate="let data of 'requests'">
    <app-vehicle-service-details-tab-requests
      [vehicleService]="vehicleService"></app-vehicle-service-details-tab-requests>
  </div>
  <div *dxTemplate="let data of 'service-states'">
    <app-vehicle-service-details-tab-service-states
      [vehicleService]="vehicleService"></app-vehicle-service-details-tab-service-states>
  </div>
  <div *dxTemplate="let data of 'schedules'">
    <app-vehicle-service-details-tab-schedules
      [vehicleService]="vehicleService"></app-vehicle-service-details-tab-schedules>
  </div>
  <div *dxTemplate="let data of 'invoices'">
    <app-vehicle-service-details-tab-invoices
      [vehicleService]="vehicleService"></app-vehicle-service-details-tab-invoices>
  </div>
  <div *dxTemplate="let data of 'fleet-manager-comments'">
    <app-vehicle-service-details-tab-fleet-manager-comments
      [vehicleService]="vehicleService"></app-vehicle-service-details-tab-fleet-manager-comments>
  </div>
</dx-tab-panel>
